import { types } from 'mobx-state-tree';

import { LicenceTypeValuesAlberta } from '../definitions/LicenseTypeValues';
import LicenceBase from './LicenceBase';


const LicenceAB = LicenceBase
    .named('LicenceAB')
    .props({
        // Note: firstLicenceType is also declared on LicenceON with
        // the same key, but different emum values.  Mobx will accept 
        // both LicenseTypeValuesOntario or LicenseTypeValuesAlberta
        // as valid values to resolve the union on ./Drivers.licencing
        firstLicenceType: types.enumeration(
            Object.values(LicenceTypeValuesAlberta),
        ),

        hasClass5GDLLicence: types.maybeNull(types.boolean),
        class5GDLLicenceAge: types.maybeNull(types.number),

        hasClass5Licence: types.maybeNull(types.boolean),
        class5LicenceAge: types.maybeNull(types.number),
    });

export default LicenceAB;
